<template>
  <!-- 목표 달성시 style="display: block;" 추가 -->
  <div class="dashboard-info">
    <div class="dashboard-info__title">
      <h3 class="title">프로모션 혜택을 받은 신규 ABO의 데이터는 익일에 반영됩니다.</h3>
    </div>

    <!-- 마감 전인 경우 -->
    <template v-if="deadline === 'N'"> 
      <div class="dashboard-info__nodata" >
        <i class="no-data-icon"></i>
        <p class="no-data-text">현재 데이터 마감 중으로 중순 이후부터 조회가 가능합니다. 감사합니다.</p>
      </div>

      

    </template>

    <!-- 자격대상이 아닌 경우 -->
    <template v-if="deadline === 'Y' && !isplatium"> 
      <div class="dashboard-info__nodata" v-if="!isplatium">
        <i class="no-data-icon"></i>
        <p class="no-data-text">해당 서비스는 3월 그룹 내 신규로 가입한 ABO가 있는 플래티늄 이상 ABO 리더님만 이용하실 수 있습니다.</p>
      </div>
    </template>
    
    <!-- 가입자 정보가 없을 경우 -->
    <template v-if="deadline === 'Y' && isplatium"> 
      <div class="dashboard-info__nodata" v-if="abocardlist.length == 0">
        <i class="no-data-icon"></i>
        <p class="no-data-text">해당 ABO정보가 없습니다.</p>
      </div>
    </template>

    <div class="dashboard-info__card" v-if="abocardlist.length > 0">
      <div class="dashboard-info__card-item" v-for="(abo, index) in abocardlist" :key="index">
        <div class="card-inner">
          <span class="num">{{index+1}}</span>
          <span class="name">{{abo.name}}</span>
          <span class="account">
            <template v-if="abo.privacy === 'Y'">{{abo.number}}</template>
            <template v-if="abo.privacy === 'N'">{{abo.number_mask}}</template>
          </span>
        </div>
      </div>
    </div>

    <div class="dashboard-info__notice">
      <p class="notice-title">알아두세요!</p>
      <div class="notice-list">
        <ul>
          <li>후원 현황은 주문 기준이며, 데이터는 익일에 반영됩니다.</li>
          <li>무통장 입금의 경우, 입금이 완료되지 않은 주문 건은 제외됩니다.</li>
          <li>보다 자세한 사항은 프로모션 안내 페이지를 참조하시기 바랍니다.</li>
        </ul>
      </div>
    </div>

    <div class="dashboard-info__banner">
      <a href="https://www.amway.co.kr/notifications/notice/detail?notificationCode=00793602&noticeType=BUSINESS">
        <img src="../assest/images/dashboard_banner_icon.png"/>신규 ABO 프로모션 <br class="mo"/>공지문 바로가기
      </a>
    </div>
    <!-- E : 20230315 대시보드 업데이트 -->
  </div>
  <!-- // 목표 달성시 style="display: block;" 추가 -->
</template>
<script>
export default {
  props: ['abocardlist', 'deadline', 'isplatium']
}
</script>
<style scoped>
@import '../assest/css/abo.css';
</style>



// WEBPACK FOOTER //
// src/views/sales/dashboard2/component/abocardList.vue